<template>
  <div class="home">
    <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-title.png" class="top-img"/>
    <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-text.png" class="top-text"/>
    <div class="content1">
      <div class="title">
        <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-text-bg.png" class="text-bg"/>
        常见用法
      </div>
      <div class="content-box">
        <div class="nav-item" @click="go(1)"><span>刚来成都有什么可以了解？</span><img src="../assets/right.png" style="width: 0.3rem;height:0.3rem"/></div>
        <div class="line"></div>
        <div class="nav-item" @click="go(2)"><span>成都有哪些人才政策？</span><img src="../assets/right.png" style="width: 0.3rem;height:0.3rem"/></div>
        <div class="line" ></div>
        <div class="nav-item" @click="go(3)"><span>我能享受哪些政策？</span><img src="../assets/right.png" style="width: 0.3rem;height:0.3rem"/></div>
        <div class="line"></div>
        <div class="nav-item" @click="go(4)"><span>我能购买人才公寓吗？</span><img src="../assets/right.png" style="width: 0.3rem;height:0.3rem"/></div>
        <!-- <div class="line"></div> -->
        <!-- <div class="nav-item" @click="go(5)"><span>我能找到就业机会吗？</span><img src="../assets/right.png" style="width: 0.3rem;height:0.3rem"/></div> -->
      </div>
    </div>
    <div class="content1">
      <div class="title">
        <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-text-bg.png" class="text-bg"/>
        平台特点
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(1)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-1.png" class="icon"/>
          政策匹配
        </div>
        <div class="line"></div>
        <div class="text">
          人才输入<span style="color:#E77625">个人基本情况</span>，即可得到适合的匹配结果，也可针对<span style="color:#E77625">专项政策回答问题</span>得到精准结果也可针对专项政策回答问题得到精准结果
        </div>
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(2)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-2.png" class="icon"/>
          人才服务
        </div>
        <div class="line"></div>
        <div class="text">
          针对来蓉人才不同阶段的现状，提供<span style="color:#E77625">青年人才驿站，人才公寓，人才充电站</span>等服务
        </div>
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(3)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-3.png" class="icon"/>
          智能客服
        </div>
        <div class="line"></div>
        <div class="text">
          在<span style="color:#E77625">人才高频问题</span>的基础上，智能客服24小时在线，为人才提供标准化的<span style="color:#E77625">政策介绍</span>和<span style="color:#E77625">服务事项解答</span>
        </div>
      </div>
    </div>
    <div class="content1">
      <div class="title">
        <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-text-bg.png" class="text-bg"/>
        走进成都
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(4)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-4.png" class="icon"/>
          创享成都
        </div>
        <div class="line"></div>
        <div class="text">
          成都的<span style="color:#E77625">视频，生活服务</span>以及<span style="color:#E77625">吃喝玩乐公众号</span>，为人才来蓉的生活提供丰富多彩的参考和选择，<span style="color:#E77625">每个公众号均可长按二维码关注</span>
        </div>
        <video poster="../assets/创享成都.png" src="https://smart.cdtalents.cn:18888/media/video/20230327/cxcd.mp4" class="videos" object-fit="contain"  controls></video>
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(5)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-5.png" class="icon"/>
          幸福蓉漂
        </div>
        <div class="line"></div>
        <div class="text">
          搜集了成都人才<span style="color:#E77625">相关资讯，最新政策动向以及各区（市）县公众号</span>，长按二维码即可关注公众号
        </div>
        <video poster="../assets/幸福蓉漂.png" src="https://smart.cdtalents.cn:18888/media/video/20230327/xfrp.mp4" class="videos" object-fit="contain"  controls></video>
      </div>
    </div>
    <div class="content1">
      <div class="title">
        <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-text-bg.png" class="text-bg"/>
        人才政策
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(6)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-6.png" class="icon"/>
          画像匹配
        </div>
        <div class="line"></div>
        <div class="text">
          人才<span style="color:#E77625">输入年龄、学历等最少4个问题</span>，即可得到适配自己的政策结果，并且查看政策详情解读
        </div>
        <video poster="../assets/画像匹配.png" src="https://smart.cdtalents.cn:18888/media/video/20230327/hxpp.mp4" class="videos" object-fit="contain"  controls></video>
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(7)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-7.png" class="icon"/>
          精准匹配
        </div>
        <div class="line"></div>
        <div class="text">
          人才可通过选择不同专项政策，<span style="color:#E77625">根据引导问题进行选择式回答，得到精准的政策结果</span>，并查看政策详情解读或跳转到相关平台进行办理
        </div>
        <video poster="../assets/精准匹配.png" src="https://smart.cdtalents.cn:18888/media/video/20230327/jzpp.mp4" class="videos" object-fit="contain" controls></video>
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(8)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-8.png" class="icon"/>
          政策查询
        </div>
        <div class="line"></div>
        <div class="text">
          包含了<span style="color:#E77625">国家级，四川省，成都市以及各区（市）县</span>政策，方便人才查阅，成都市政策已打通立即办理功能，方便人才进行一站式功能体验
        </div>
      </div>
    </div>
    <div class="content1">
      <div class="title">
        <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-text-bg.png" class="text-bg"/>
        人才服务
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(9)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-9.png" class="icon"/>
          青年人才驿站
        </div>
        <div class="line"></div>
        <div class="text">
          可通过地图和列表模式查看成都市青年人才驿站，VR和相册在线浏览驿站照片，并通过申请入住功能完成办理。
        </div>
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(10)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-10.png" class="icon"/>
          人才公寓
        </div>
        <div class="line"></div>
        <div class="text">
          可通过地图和列表模式查看成都市人才公寓信息，包括楼盘信息，户型，配套等，并进行人才安居相关政策匹配，政策详情查看以及一键申请
        </div>
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(11)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-11.png" class="icon"/>
          人才充电站
        </div>
        <div class="line"></div>
        <div class="text">
          包含成都市26个重点产业链行研报告，为人才提供产业链专业资讯
        </div>
      </div>
    </div>
    <div class="content1">
      <div class="title">
        <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-text-bg.png" class="text-bg"/>
        人才机遇
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(12)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-12.png" class="icon"/>
          蓉漂杯
        </div>
        <div class="line"></div>
        <div class="text">
          同步“蓉漂杯”官方大赛信息，可以直接报名参赛
        </div>
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(13)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-13.png" class="icon"/>
          蓉漂人才荟
        </div>
        <div class="line"></div>
        <div class="text">
          为人才提供多元化多行业的招聘会和岗位信息，并可与招聘方在线联系
        </div>
      </div>
    </div>
    <div class="content1">
      <div class="title">
        <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-text-bg.png" class="text-bg"/>
        服务中心
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(14)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-14.png" class="icon"/>
          智能客服
        </div>
        <div class="line"></div>
        <div class="text">
          24小时在线解答高频问题
        </div>
      </div>
      <div class="content-box">
        <div class="head" @click="toFunction(15)">
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-15.png" class="icon"/>
          留言反馈
        </div>
        <div class="line"></div>
        <div class="text">
          通过图文形式反馈平台使用意见
        </div>
      </div>
    </div>
    <div class="content1">
      <div class="title">
        <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-text-bg.png" class="text-bg"/>
        皮肤切换
      </div>
      <div class="content-box">
        <div class="head" style="text-decoration:none;color:#333" >
          <img src="https://smart.cdtalents.cn:18888/media/files/20230324/oneKnow/oneKnow-17.png" class="icon"/>
          双色切换
        </div>
        <div class="line"></div>
        <div class="text">
          一键切换“深色“和”浅色“两种皮肤模式，方便人才根据光线调整
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
    }
  },
  created() { },
  mounted() { },
  methods: {
    go(params){
      this.$router.push({
        path: '/normal',
        query:{
          id:params
        }
      })
    },
    toFunction(key){
      switch (key) {
        case 1:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/AImatch/AImatch`
         })
          break;
        case 2:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/talentService/talentStage`
         })
          break;
        case 3:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/map/robot`
         })
          break;
        case 4:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/talentView/talentView`
         })
          break;
        case 5:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/index/newsList`
         })
          break;
        case 6:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/AImatch/match`
         })
          break;
        case 7:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/AImatch/AImatch`
         })
          break;
        case 8:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/policyChannel/policyQuery`
         })
          break;
        case 9:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/talentService/talentStage`
         })
          break;
        case 10:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/talentService/talentService`
         })
          break;
        case 11:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/talentKnowlege/index`
         })
          break;
        case 12:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/startBusiness/startBusiness`
         })
          break;
        case 13:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/webview/webview?url=https%3A%2F%2Fcdcszbj.zhaopin.com%2F`
         })
          break;
        case 14:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/map/robot`
         })
          break;
        case 15:
        wx.miniProgram.redirectTo({
          // url: `/pages/talentView/talentView?weburl=https://cdtalent.jianshankeji.com/talentPolicy/#/normal?id=1`
          url: `/pages/personal/advice`
         })
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  box-sizing: border-box;
  min-height: 100vh;
  color: #000;
  background-size: contain;
  background-repeat: no-repeat;
  padding: 0.32rem;
  width: 7.5rem;
  position: relative;
  margin: 0 auto;
  background-color: #f7f6f9;

  .top-img {
    position: absolute;
    top: -0.9rem;
    left: 0;
    width: 7.5rem;
    height:5.59rem;
  }

  .top-text {
    position: relative;
    width: 6.86rem;
    height: 3.80rem;
    margin-top: 3.2rem;
    z-index: 99;
  }

  .content1 {
    .title {
      width: 1.57rem;
      height: 0.5rem;
      position: relative;
      font-size: 0.34rem;
      font-weight: bold;
      word-break: keep-all;
      color: #333333;

      .text-bg {
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
.nav-item{
font-size: 0.28rem;
width: 100%;
height: 0.5rem;
font-weight: 500;
color: #313E62;
line-height: 42rpx;
display: flex;
align-items: center;
justify-content: space-between;
text-indent: 1em;
position: relative;
&::before{
  content: '';
  position: absolute;
  left: 0;
  width: 0.09rem;
  height: 0.09rem;
  border-radius: 50%;
  background-color: #0F75FF;
}
    }
    .content-box {
      margin-top: 0.24rem;
      margin-bottom: 0.24rem;
      width: 6.86rem;
      background-color: rgb(254, 254, 254);
      padding: 0.18rem;
      box-sizing: border-box;
      border-radius: 0.1rem;
text-align: left;
      .head {
        font-size: .32rem;
        font-weight: bold;
        color: #006CFF;
        display: flex;
        text-decoration: underline;
        align-items: center;

        .icon {
          width: .44rem;
          height: .44rem;
          margin-right: .10 rem;
        }
      }
      .line{
        width: 100%;
        height: 0.02rem;
        background-color: #BCCAF1;
        margin-top: 0.20rem;
        margin-bottom: 0.20rem;
        opacity: 0.5;
      }
      .text{
        font-size: .28rem;
        color: #313E62;
        line-height: .42rem;
        font-weight: 500;
      }
      .videos{
        margin-top: .25rem;
        width: 100%;
      }
    }
  }
}
</style>